import React, { useEffect, useState } from "react";

function FormatArea({ area }) {
  const [areaFormat, setAreaFormat] = useState();
  useEffect(() => {
    setAreaFormat(area);
  }, [area]);
  return (
    <span>
      {/* {areaFormat > 10000 ? (
        <span>
          {Math.round((areaFormat / 1000000) * 100) / 100} km<sup>2</sup>
        </span>
      ) : (
        <span>{Math.round(areaFormat * 100) / 100} m<sup>2</sup></span>
      )} */}
      {(areaFormat / 4046.85642).toFixed(3)} Acre
    </span>
  );
}
export default FormatArea;
